import React, {Component} from "react";
import {Growl} from 'primereact/growl';
import ConcentratedPositionView from "./ConcentratedPositionView";
import {ReportsService} from "../../../service/reports/ReportsService";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import ConfirmationMessage from "../../../components/confirmationMessage";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {dateFormatterReportTable} from "../../../utils/formatters/Date";
import {INTERNO_STR} from "../../../utils/constants/Constants";

export default class ActiveGuaranteesDetailContainer extends Component {
    constructor(props) {
        super(props);

        this.reportsService = new ReportsService();
        this.getDataReport = this.getDataReport.bind(this);
        this.exportDocument = this.exportDocument.bind(this);
        this.confirmationRef = null;
        this.today = new Date();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        };

        let columns = [
            {field: "fecha", header: "Fecha", body: dateFormatterReportTable},
            {field: "razonSocial", header: "Institución", style: {textAlign: 'left', width: '200px'}},
            {field: "cuenta", header: "Cuenta"},
            {field: "emisora", header: "Emisora"},
            {field: "serie", header: "Serie"},
            {field: "tipoValor", header: "Tipo Valor"},
            {field: "cupon", header: "Cupón"},
            {field: "cantidad", header: "Títulos", style: {textAlign: 'right', width: '100px'}},
        ];

        this.state = {
            isLoading: false,
            cols: columns,
            filters: {
                detailCheck: true,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
            dataReport: [],
            exportOptions: [
                {
                    label: "Excel", action: () => {
                        this.openConfirmationMessage("Excel")
                    }
                },
                {
                    label: "PDF", action: () => {
                        this.openConfirmationMessage("PDF")
                    }
                },
            ],
            typeDocument: '',
            disabledSearchButton: false,
        };

        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);
        this.openConfirmationMessage = this.openConfirmationMessage.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.loading = this.loading.bind(this);
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;

        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }

        if (localStorage.getItem('institution') !== INTERNO_STR){
            let colsAux = this.state.cols;
            colsAux.splice(1, 1);
            this.setState({
                cols: colsAux,
            });
        }
    }

    loading(option) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: option ? option : false,
            });
        }
    }

    clearFilters() {
        this.setState({
            filters: {
                guaranteeCheck: false,
                startDate: this.today,
                finalDate: this.today,
                today: this.today,
            },
        });
    }

    onChangeFilters(event) {
        let filtersAux = this.state.filters;

        if (event.target.name === "startDate") {
            filtersAux[event.target.name] = event.target.value;
            filtersAux['finalDate'] = event.target.value;
        } else {
            filtersAux[event.target.name] = event.target.value ? event.target.value : event.checked;
        }
        this.setState({
            filters: filtersAux,
        });
    }

    rowExpansionTemplate(data) {
        const guaranteesItems = data.detalle;
        return (
            <Grid container direction="row" justify="space-evenly" alignItems="right">
                <Grid item xs={6}/>
                <Grid item xs={6}>
                    <DataTable
                        value={guaranteesItems}
                        resizableColumns={true}
                        columnResizeMode={"fit"}>
                        <Column field="folio" header="Folio Préstamo" style={{textAlign: 'left'}} sortable={true}/>
                        <Column field="cantidad" header="Titulos" style={{textAlign: 'right'}} sortable={true}/>
                    </DataTable>
                </Grid>
            </Grid>
        );
    }

    rowGroupHeaderTemplate(data) {
        let headerName = data.rol === 'PTM' ?
            "Emisoras en Préstamo" : "Emisoras en Garantía";
        return (
            <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}>
                {headerName}
            </Typography>);
    }

    openConfirmationMessage(docType) {
        if (this.confirmationRef) {
            this.setState({
                typeDocument: docType
            });
            this.confirmationRef.openConfirmationMessage();
        }
    }

    getDataReport() {
        this.loading(true);
        this.setState({
            disabledSearchButton: true,
        });
        this.reportsService.getConcentratedPositionReport(this.state.filters)
            .then(resp => {
                let expandedRowsAux = [];
                if (resp.error !== '') {
                    this.growl.show({
                        severity: 'info', summary: 'Atención.',
                        detail: resp.error
                    });
                } else {
                    if (this.state.filters.detailCheck) {
                        resp.payload.map((row) => {
                            return (row.detalle.length === 0 ? '' : expandedRowsAux.push(row));
                        });
                    }
                }
                this.setState({
                    dataReport: resp.payload,
                    expandedRows: expandedRowsAux,
                    disabledSearchButton: false,
                });
                this.loading(false);
            });
    }

    exportDocument() {
        this.loading(true);
        if (this.state.dataReport.length === 0) {
            this.growl.show({
                severity: 'info', summary: 'Atención.',
                detail: 'No existen datos'
            });
            this.loading(false);
        } else {
            let params = {
                bandera: 0,
                tipoReporte: 8,
                fechaInicial: this.state.filters.startDate.getFullYear() + "-" +
                    (this.state.filters.startDate.getMonth() + 1) + "-" +
                    this.state.filters.startDate.getDate(),
                fechaFinal: this.state.filters.finalDate.getFullYear() + "-" +
                    (this.state.filters.finalDate.getMonth() + 1) + "-" +
                    this.state.filters.finalDate.getDate(),
                chkDetalle: this.state.filters.detailCheck,
            };
            switch (this.state.typeDocument) {
                case "Excel":
                    this.reportsService.getPositionReportXLS(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                case "PDF":
                    this.reportsService.getPositionReportPDF(params)
                        .then(res => {
                            this.getDataReport();
                            this.loading(false);
                        });
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        let confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                           invisible={true}
                                           legend="¿Usted está seguro de continuar descargando la información solicitada?"
                                           action={this.exportDocument}/>;
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {
            dataReport, isLoading, expandedRows,
            filters, exportOptions, disabledSearchButton
        } = this.state;
        let columns = this.state.cols.map((col, i) => {
            return <Column field={col.field}
                           header={col.header}
                           style={col.style ? col.style : {textAlign: 'left', width: '100px'}}
                           sortable={true}
                           body={col.body ? col.body : ''}
            />;
        });

        return <ConcentratedPositionView
            dataReport={dataReport}
            isLoading={isLoading}
            messagesGrowl={messagesGrowl}
            columns={columns}
            filters={filters}
            expandedRows={expandedRows}
            exportOptions={exportOptions}
            confMsg={confMsg}
            disabledSearchButton={disabledSearchButton}
            onChangeFilters={this.onChangeFilters}
            rowExpansionTemplate={this.rowExpansionTemplate}
            getDataReport={this.getDataReport}
            clearFilters={this.clearFilters}
            rowGroupHeaderTemplate={this.rowGroupHeaderTemplate}
        />
    }
};